let counter = 0;
export const newClientKey = (): string => `cbn-msg-${Date.now().toString(36)}-${(counter++).toString(36)}`;
